import { render, staticRenderFns } from "./BusinessDocumentDetailsList.vue?vue&type=template&id=17059f2a&"
import script from "./BusinessDocumentDetailsList.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17059f2a')) {
      api.createRecord('17059f2a', component.options)
    } else {
      api.reload('17059f2a', component.options)
    }
    module.hot.accept("./BusinessDocumentDetailsList.vue?vue&type=template&id=17059f2a&", function () {
      api.rerender('17059f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentDetailsList.vue"
export default component.exports